var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPulsIconYellow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 35.129,
    height: 38.629,
    viewBox: "0 0 35.129 38.629",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Trac\\xE9_276",
    x: 0,
    y: 0,
    width: 35.129,
    height: 38.629,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    filter: "url(#Trac\\xE9_276)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_276-2",
    "data-name": "Trac\\xE9 276",
    d: "M-1387.2,1101.608a1.321,1.321,0,0,1,.917-.934,2.43,2.43,0,0,1,.555-.049q5,0,9.995,0h.356v-.355c0-3.289.014-6.578-.01-9.867a1.454,1.454,0,0,1,.995-1.6h.51a1.325,1.325,0,0,1,.934.918,2.44,2.44,0,0,1,.049.556q0,5,0,10c0,.348,0,.348.337.348q5.038,0,10.077,0a1.311,1.311,0,0,1,1.161.509,1.177,1.177,0,0,1,.126,1.254,1.17,1.17,0,0,1-1.014.708c-.127.011-.255.011-.382.011H-1372.9v.355q0,5.026,0,10.051a1.321,1.321,0,0,1-.5,1.164,1.176,1.176,0,0,1-1.253.133,1.17,1.17,0,0,1-.713-1.01c-.011-.127-.012-.255-.012-.382q0-4.975,0-9.949c0-.408.041-.361-.374-.362-3.282,0-6.565-.014-9.847.009a1.452,1.452,0,0,1-1.6-.995Z",
    transform: "translate(1391.7 -1088.8)",
    fill: "#ffc654"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPulsIconYellow);
export default __webpack_public_path__ + "static/media/puls-icon-yellow.baec48a3ee64e7a8717a2d2aad78f112.svg";
export { ForwardRef as ReactComponent };